<div class="book-call-layout">
  <div class="content-box" *ngIf="!success">
    <p>Book a call</p>
    <span>We will call you for 15 minutes</span>
    <div class="book-box">
      <div class="form-box">
        <div class="form-section">
          <div class="input-box margin-r">
            <label for="firstName">Your Name</label>
            <input type="text" placeholder="Jonatan" />
          </div>
          <div class="input-box">
            <label for="Your Phone">Your Phone</label>
            <input type="text" placeholder="(995) 363-8333" />
          </div>
        </div>
        <div class="form-section">
          <div class="input-box input-w-full">
            <label for="Your comment">Your comment</label>
            <input type="text" placeholder="Text" />
          </div>
        </div>

        <div class="form-btn">
          <button class="btn-outline margin-r" routerLink="/form/rate">
            Back
          </button>
          <button class="btn-normal" (click)="bookToCall()">Confirm</button>
        </div>
      </div>
    </div>
  </div>

  <div class="sucess-box" *ngIf="success">
    <div class="book-box">
      <div class="image-header">
        <div class="round-shape">
          <img src="../../../../../assets/icon/check_24.png" alt="" />
        </div>
        <img src="../../../../../assets/stars.png" alt="" />
      </div>
      <p>Call request sent</p>
      <span>We will call you for 15 minutes</span>

      <div class="section-or">
        <div></div>
        <span>or</span>
        <div></div>
      </div>

      <div class="success-box">
        <p>Don’t want to wait?</p>
        <span>Call us at this number 410-580-2800</span>
      </div>

      <button class="btn-normal">Go to Home Page</button>
    </div>
  </div>
</div>
